/** @module csi/widget/_svg/ImagePlaceholder */
define([
	"dijit/form/ToggleButton",
	"csi/locale",
	"./_Plugin",
	"./PluginFactory"
], function(ToggleButton,locale,_Plugin,PluginFactory) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-toggle",
		iconClass: "csiActionIcon svgIconImagePlaceholder",
		pluginName: "imagePlaceholder",
		title: locale.resource("ImagePlaceholder"),

		/**
		 * @override
		 * Only show plugin for canvas templates in edit mode
		 * @return {boolean}
		 */
		canShowPlugin: function() {
			return (!!this.editor.editMode && this.getView().isCanvasTemplate());
		},

		/**
		 * Enable and disable the icon
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set('checked', this.editor.isDrawPlaceholder() && this.editor.isDrawCanvasMode());
			return true;
		},

		/**
		 * Set icon to be depressed
		 */
		onClick: function() {
			var imagePlaceholderShape = this.editor.getStorageProperty("shapeProperties.spPr.geometry.presetShape") || "rect";

			if (imagePlaceholderShape) {
				this.editor.setDrawMode(imagePlaceholderShape, true, false, false, true);
			}
			this.set('checked', true);
		}
	});
});
